import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "f44382cb-6180-4dfc-9a0e-d842200ff0e2", content: "all locations on the Horizontal Plane", options: {} },
  {
    id: "e7d048b7-bb53-4f5b-8adf-1fdbfbc9aefb",
    content: "no sound source positions with zero ITD and ILD exist",
    options: {},
  },
  { id: "9ceb41a7-e6cb-4053-bab1-1588e746bc94", content: "all locations with θ = 0°", options: {} },
  { id: "cabc2d62-97db-4485-b178-a7dabf116e58", content: "all locations on the Median Plane", options: {} },
  { id: "b039b19b-fcd4-4f6c-8317-7e6ed66e448d", content: "all locations with Φ = 0°", options: {} },
  { id: "51590a2a-7d1a-466d-a408-66a97f6393e8", content: "all locations with Φ = 90°", options: {} },
];

export const task: Task = {
  id: "0d42f5a0-2d82-479c-84ea-d02ec6d7c2da",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    shuffle: true,
    columns: 1,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["cabc2d62-97db-4485-b178-a7dabf116e58", "b039b19b-fcd4-4f6c-8317-7e6ed66e448d"],
};
